import { render, staticRenderFns } from "./LamboPreOwnedHeader.vue?vue&type=template&id=22d9787c&scoped=true&"
import script from "./LamboPreOwnedHeader.vue?vue&type=script&lang=js&"
export * from "./LamboPreOwnedHeader.vue?vue&type=script&lang=js&"
import style0 from "./LamboPreOwnedHeader.vue?vue&type=style&index=0&id=22d9787c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d9787c",
  null
  
)

export default component.exports